import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface WorkspaceRedirectDialogProps {
  open: boolean;
  targetWorkspaceName: string;
  onAccept: () => void;
  onCancel: () => void;
}

// Shown when a notification (count/export result) belongs to a different workspace than the one
// the user is currently on — switching workspaces resets whatever unsaved state the current page
// holds (query builder, animation draft...), so this is a deliberate confirm step, not a silent redirect.
function WorkspaceRedirectDialog({ open, targetWorkspaceName, onAccept, onCancel }: WorkspaceRedirectDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <WarningAmberIcon sx={{ color: 'warning.main' }} />
        <Typography variant="subtitle1" fontWeight={700}>
          Changement d'enseigne
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: '0.9rem', color: 'text.primary' }}>
          Attention, vous allez être redirigé vers l'enseigne <strong>{targetWorkspaceName.toUpperCase()}</strong>.
          Pensez à sauvegarder votre travail en cours avant de continuer.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0 }}>
        <Button onClick={onCancel} sx={{ textTransform: 'none', color: 'text.secondary' }}>
          Refuser
        </Button>
        <Button
          variant="contained"
          onClick={onAccept}
          sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: 'primary.main', '&:hover': { backgroundColor: 'primary.main', opacity: 0.9 } }}
        >
          Accepter
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WorkspaceRedirectDialog;
